import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { redirect, useParams } from "react-router";

import DOMPurify from "dompurify";

import { store } from "../..";
import { alertActions } from "../../features/alert/alertSlice";
import {
    globalActions,
    selectSetting,
} from "../../features/global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { acceptWaiver, verifyPlayer } from "../../lib/api";

export const loader = async ({ params }: { params: any }) => {
    const { playerId } = params;

    const player = await verifyPlayer(parseInt(playerId));

    const settings = store.getState().global.settings;
    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    await Promise.resolve(settingsPromise);

    if (!player || !player.player) {
        return redirect("/");
    } else {
        return null;
    }
};

const Waiver = (): React.JSX.Element => {
    const { playerId } = useParams() as { playerId: string };
    const dispatch = useAppDispatch();

    const waiverText = useAppSelector(state =>
        selectSetting(state, "wibb_waiver_text"),
    );

    const handleWaiverClick = () => {
        acceptWaiver(parseInt(playerId))
            .then(() => {
                dispatch(
                    alertActions.success({
                        title: `Waiver accepted`,
                        dismissible: true,
                    }),
                );
            })
            .catch(e => {
                dispatch(
                    alertActions.error({
                        title: `The server encountered a problem accepting the waiver.`,
                        text: "If the problem continues, please reach out to your teams coach or an admin.",
                        dismissible: true,
                    }),
                );
            });
    };
    return (
        <Container data-testid="waiver" className="py-5 waiver">
            <Row>
                <Col>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(waiverText?.setting),
                        }}
                    />
                    <Button onClick={handleWaiverClick}>Accept Waiver</Button>
                </Col>
            </Row>
        </Container>
    );
};

export default Waiver;
